// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3mU8V","actions":"GroupTable_actions__15py1","deleteModalFooter":"GroupTable_deleteModalFooter__2N6WD"};